import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["value", "onValueChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useState, useEffect, useMemo } from 'react';
import { clamp, debounce } from 'lodash';
import Button from "@scentregroup/ui/components/form/button";
import Label from "@scentregroup/ui/components/form/label";
import trackMkpEvent, { labels } from '../../../../apps/checkout/src/client/lib/market-place-track-event';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SOURCE;

(function (SOURCE) {
  SOURCE["INPUT"] = "INPUT";
  SOURCE["DECREMENT"] = "DECREMENT";
  SOURCE["INCREMENT"] = "INCREMENT";
})(SOURCE || (SOURCE = {}));

const DEBOUNCE_DELAY = 500;
const STEP_RATE = 1;
const LABEL = 'Quantity';
const ID = 'quantity';
const NAME = 'quantity';
const MIN = 1;
export const QuantityDebounce = _ref => {
  let {
    value,
    onValueChange
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  const debounceOnChange = useMemo(() => debounce(value => onValueChange(value), DEBOUNCE_DELAY), [onValueChange]);

  const handleValueChange = (nextValue, source) => {
    if (source === SOURCE.DECREMENT || source === SOURCE.INCREMENT) {
      debounceOnChange(nextValue);
    } else {
      onValueChange(nextValue);
    }
  };

  return /*#__PURE__*/_jsx(Quantity, _objectSpread(_objectSpread({
    isDebounced: true,
    value: value,
    onValueChange: handleValueChange
  }, props), {}, {
    "data-id": "cart-preview-quantity-experiment_index_QuantityDebounce_Quantity"
  }));
};

const Quantity = _ref2 => {
  let {
    id = ID,
    name = NAME,
    label = LABEL,
    value,
    min = MIN,
    max,
    onValueChange,
    disabled,
    stepRate = STEP_RATE,
    hideLabel = false,
    isDebounced = false
  } = _ref2;
  const {
    0: inputValue,
    1: setInputValue
  } = useState(value.toString());
  const inputDisabled = disabled || max === 0;
  const increaseDisabled = disabled || inputValue !== '' && parseInt(inputValue) >= max;
  const decreaseDisabled = disabled || inputValue === '' || parseInt(inputValue) <= min;
  useEffect(() => {
    if (!isDebounced) {
      setInputValue(value.toString());
    }
  }, [value, isDebounced]);

  const updateValue = (nextValue, source) => {
    setInputValue(nextValue.toString());

    if (nextValue !== value) {
      onValueChange(nextValue, source);
    }
  };

  const triggerOnChange = currentValue => {
    setInputValue(currentValue ? clamp(parseInt(currentValue), min, max).toString() : '');
  };

  const handleChange = event => {
    triggerOnChange(event.target.value);
  };

  const handleBlur = () => {
    updateValue(inputValue ? parseInt(inputValue) : min, SOURCE.INPUT);
  };

  const handleDecrementClick = () => {
    trackMkpEvent.clicked(labels.DECREASE_QUANTITY);
    updateValue(parseInt(inputValue) - stepRate, SOURCE.DECREMENT);
  };

  const handleIncrementClick = () => {
    trackMkpEvent.clicked(labels.INCREASE_QUANTITY);
    updateValue(parseInt(inputValue) + stepRate, SOURCE.INCREMENT);
  };

  const handleInputFocus = () => {
    trackMkpEvent.clicked(labels.FOCUS_QUANTITY);
  };

  return /*#__PURE__*/_jsxs("div", {
    "data-id": "cart-preview-quantity-experiment_index_QuantityDebounce_div",
    children: [label && !hideLabel && /*#__PURE__*/_jsx(Label, {
      for: id,
      className: style.quantityLabel,
      "data-id": "cart-preview-quantity-experiment_index_QuantityDebounce_Label",
      children: label
    }), /*#__PURE__*/_jsxs("div", {
      className: style.quantityWrapper,
      "data-id": "cart-preview-quantity-experiment_index_QuantityDebounce_div_div",
      children: [/*#__PURE__*/_jsx(Button, {
        "aria-hidden": true,
        "data-test-id": "decrease-quantity-btn",
        type: "inferior",
        buttonType: "button",
        className: style.button,
        disabled: decreaseDisabled,
        tabIndex: "-1",
        onClick: handleDecrementClick,
        "data-id": "cart-preview-quantity-experiment_index_QuantityDebounce_div_Button",
        children: "-"
      }), /*#__PURE__*/_jsx("input", {
        type: "number",
        id: id,
        name: name,
        min: min,
        max: max,
        value: inputValue,
        className: style.quantity,
        autoComplete: "off",
        pattern: "[0-9]*",
        disabled: inputDisabled,
        onChange: handleChange,
        onBlur: handleBlur,
        onFocus: handleInputFocus,
        "data-id": "cart-preview-quantity-experiment_index_QuantityDebounce_div_input"
      }), /*#__PURE__*/_jsx(Button, {
        "aria-hidden": true,
        "data-test-id": "increase-quantity-btn",
        type: "inferior",
        buttonType: "button",
        className: style.button,
        disabled: increaseDisabled,
        tabIndex: "-1",
        onClick: handleIncrementClick,
        "data-id": "cart-preview-quantity-experiment_index_QuantityDebounce_div_Button",
        children: "+"
      })]
    })]
  });
};

export default Quantity;